import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon, BookIcon } from 'lucide-react';
interface GLCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}
export function GLCodeInput({
  value,
  onChange,
  error
}: GLCodeInputProps) {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isValid, setIsValid] = useState(true);
  // Sample GL codes for suggestions
  const sampleGLCodes = ['1000.1100', '1000.1200', '1500.100', '2000.1000', '2000.2000', '3000.1000', '3000.3000', '4000.1000', '5000.1000', '6000.1000', '6100.100', '6200.200', '6300.300', '6400.100', '6500.300' // Training Expense
  ];
  // Validate GL code format
  const validateGLCode = (code: string): boolean => {
    // Basic validation: should be in format like 1000.1000 or 1000.1000.1000
    const regex = /^\d+(\.\d+)*$/;
    return regex.test(code);
  };
  // Update suggestions when input changes
  useEffect(() => {
    if (value.length > 0) {
      const filtered = sampleGLCodes.filter(code => code.startsWith(value));
      setSuggestions(filtered);
      setIsValid(validateGLCode(value));
    } else {
      setSuggestions([]);
      setIsValid(true);
    }
  }, [value]);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
    setShowSuggestions(true);
  };
  const handleSuggestionClick = (suggestion: string) => {
    onChange(suggestion);
    setShowSuggestions(false);
  };
  const handleBlur = () => {
    // Delay hiding suggestions to allow for clicks
    setTimeout(() => {
      setShowSuggestions(false);
    }, 200);
  };
  return <div className="relative" data-id="element-6880">
      <div className="relative" data-id="element-6881">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-6882">
          <BookIcon className="h-5 w-5 text-gray-400" data-id="element-6883" />
        </div>
        <input type="text" value={value} onChange={handleInputChange} onBlur={handleBlur} onFocus={() => setShowSuggestions(true)} placeholder="Enter GL Code (e.g., 1000.1000)" className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md ${error ? 'border-red-300' : !isValid && value ? 'border-yellow-300' : ''}`} data-id="element-6884" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-6885">{error}</p>}
      {!isValid && value && !error && <div className="mt-1 flex items-center text-sm text-yellow-600" data-id="element-6886">
          <AlertTriangleIcon className="h-4 w-4 mr-1" data-id="element-6887" />
          <span data-id="element-6888">
            GL Code format should be numbers separated by periods (e.g.,
            1000.1000)
          </span>
        </div>}
      {showSuggestions && suggestions.length > 0 && <div className="absolute z-10 w-full mt-1 bg-white shadow-lg rounded-md border border-gray-200 max-h-60 overflow-auto" data-id="element-6889">
          <ul className="py-1" data-id="element-6890">
            {suggestions.map(suggestion => <li key={suggestion} onClick={() => handleSuggestionClick(suggestion)} className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" data-id="element-6891">
                <span className="font-mono" data-id="element-6892">{suggestion}</span>
              </li>)}
          </ul>
        </div>}
    </div>;
}